import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/FileDownloadColor.tsx
const FileDownloadColorIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-.293-.707l-5-5A1 1 0 0 0 14 2H7Zm7 2v3a1 1 0 0 0 1 1h3l-4-4Zm-1 7a1 1 0 1 0-2 0v3.586l-.793-.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l2.5-2.5a1 1 0 0 0-1.414-1.414l-.793.793V11Z",
		fill: "url(#paint0_linear_871_1262)"
	}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", {
		id: "paint0_linear_871_1262",
		x1: 12,
		y1: 2,
		x2: 12,
		y2: 22,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ jsx("stop", { stopColor: "#3CD84C" }),
			/* @__PURE__ */ jsx("stop", {
				offset: .5,
				stopColor: "#6EBFFF"
			}),
			/* @__PURE__ */ jsx("stop", {
				offset: 1,
				stopColor: "#A49BFF"
			})
		]
	}) })]
}));
//#endregion
export { FileDownloadColorIcon };
